'use client';

import { useClientHasRendered } from '../../helpers/hooks';
import { useFeatureFlags } from '../../helpers/hooks/useFeatureFlags';
import { SupportChat } from './SupportChat';
import { ZendeskSupportChat } from './ZendeskSupportChat';

// This component conditionally renders either the ZendeskSupportChat or SupportChat component
// A client component wrapper is needed to handle feature flags and client-side rendering
// remove wrapper when removing feature flag
export const SupportChatWrapper = ({
  hasStickyBottomBanner = false,
  hideStickyBannerGetApp = false,
  disableSupportChat = false,
}: {
  hasStickyBottomBanner?: boolean;
  hideStickyBannerGetApp?: boolean;
  disableSupportChat?: boolean;
}) => {
  const featureflags = useFeatureFlags(['zendesk']);
  const isZendeskEnabled = featureflags.zendesk;
  const clientHasRendered = useClientHasRendered();

  if (!clientHasRendered) {
    return <></>;
  }

  return isZendeskEnabled ? (
    <ZendeskSupportChat
      hasStickyBottomBanner={hasStickyBottomBanner || !hideStickyBannerGetApp}
      disableSupportChat={disableSupportChat}
    />
  ) : (
    <SupportChat
      hasStickyBottomBanner={hasStickyBottomBanner || !hideStickyBannerGetApp}
      disableSupportChat={disableSupportChat}
    />
  );
};
